import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import EnumCacheService from '@/shared/services/EnumCacheService';
import EnumMultiSelect from '@/shared/components/input/multiselect/EnumMultiSelect';
import EditableToggle from './EditableToggle';
const parseValue = (value) => {
    if (!value)
        return [];
    if (Array.isArray(value))
        return value;
    if (typeof value === 'string') {
        return value
            .replace(/\s/g, '')
            .split(',')
            .filter(Boolean)
            .map(Number)
            .filter(n => !isNaN(n));
    }
    return [];
};
const EditableEnumMultiSelect = ({ onChange, value, enumType, readOnly = false, placeholder = '', itemMapper, }) => {
    const intl = useIntl();
    const [items, setItems] = useState([]);
    useEffect(() => {
        let mounted = true;
        EnumCacheService.getTranslated(enumType, intl, false).then((values) => {
            if (mounted)
                setItems(values);
        });
        return () => {
            mounted = false;
        };
    }, [intl, enumType]);
    const selectedIds = parseValue(value);
    const displayValue = selectedIds
        .map(id => {
        var _a;
        const item = items.find(i => Number(i.id) === id);
        return (_a = item === null || item === void 0 ? void 0 : item.label) !== null && _a !== void 0 ? _a : String(id);
    })
        .join(', ');
    const handleSubmit = useCallback((editValue) => onChange(editValue || []), [onChange]);
    return (_jsx(EditableToggle, Object.assign({ onSubmit: handleSubmit, value: selectedIds, readOnly: readOnly, displayValue: displayValue ? _jsx("span", { children: displayValue }) : _jsx("i", { className: "glyphicon glyphicon-pencil" }) }, { children: ({ inputValue, setInputValue, submit }) => (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: submit }, { children: _jsx(EnumMultiSelect, { type: enumType, selection: inputValue || [], onChange: (newSelection) => setInputValue(newSelection), placeholder: placeholder, sortById: false, customItems: [], itemMapper: itemMapper }) }))) })));
};
export default EditableEnumMultiSelect;
